var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      pug_mixins["intro"] = pug_interp = function(data){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!data) { data={is_bonus: false}; }
if (data.process === 'NEO') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" ng-class=\"{highlighted: &quot;intro&quot; == component.box.step}\"\u003E\u003Cdiv class=\"header\" ng-class=\"{show: &quot;intro&quot; == component.box.step }\"\u003E\u003Ca ng-click=\"component.toggleStep(&quot;intro&quot;)\"\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'So funktioniert´s') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"&quot;intro&quot; == component.box.step\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E";
if (data.video) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.video, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"subtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cp class=\"error\" ng-show=\"component.is_already_used\"\u003ESie nutzen bereits diesen Baustein!\u003C\u002Fp\u003E\u003Ca class=\"button button-primary float-right\" ng-click=\"component.toggleStep(&quot;values&quot;)\" ng-if=\"!component.is_pc\" data-cy=\"neo.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003EWeiter\u003C\u002Fa\u003E\u003Ca class=\"button button-primary right\" ng-click=\"component.goToMPP()\" ng-if=\"component.is_pc\" data-cy=\"neo.preCheckout.pcLeasing.wizardBegin.buttonNext\"\u003EWeiter\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'BONUS') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'So funktioniert´s') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E";
if (data.video) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.video, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
if (data.image) {
pug_html = pug_html + "\u003Cdiv class=\"baustein\"\u003E\u003Cdiv class=\"bausteinContainer\"\u003E\u003Ca" + (" class=\"imgWrapper\""+pug.attr("ng-href", '/module/' + data.image, true, true)) + "\u003E\u003Cdiv" + (" class=\"imgContainer\""+pug.attr("style", pug.style('background-image: url(/assets/img/bonus/' + data.image + '.jpg)'), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"subtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle2) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cbr\u003E";
block && block();
pug_html = pug_html + "\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"component.isBonusCancelled() || !component.isProjectApproved()\"\u003E\u003Cp class=\"red\"\u003EDer Checkout ist leider nicht möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!component.hasSachbezugCheckouts &amp;&amp; component.all_active_checkouts.length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESie nutzen bereits diese Wahlleistung für den Zeitraum\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.all_active_checkouts\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cspan class=\"red\" ng-if=\"component.hasSachbezugCheckouts\"\u003ESie nutzen bereits diese Wahlleistung für den Zeitraum\u003C\u002Fspan\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"component.allSachbezugCheckouts['sachbezug'] &amp;&amp; component.allSachbezugCheckouts['sachbezug'].length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESACHBEZUG | VORTEILSKONTO\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.allSachbezugCheckouts['sachbezug']\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"component.allSachbezugCheckouts['sachbezug_pluxee'] &amp;&amp; component.allSachbezugCheckouts['sachbezug_pluxee'].length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESACHBEZUG | BENEFITS CARD\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.allSachbezugCheckouts['sachbezug_pluxee']\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"component.allSachbezugCheckouts['sachbezug_profit'] &amp;&amp; component.allSachbezugCheckouts['sachbezug_profit'].length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESACHBEZUG | FITNESSKONTO\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.allSachbezugCheckouts['sachbezug_profit']\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"!component.isBonusDefaultStartDateCheckoutAvailable &amp;&amp; !component.is_component_cashback\"\u003E\u003Cp class=\"red\"\u003EDiese Wahlleistung steht in diesem Projekt aktuell nicht zur Verfügung.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"(component.is_component_cashback &amp;&amp; !component.is_cashback_request_available) || !component.isDecisionDateValid()\"\u003E\u003Cp class=\"red\"\u003EDer Zeitraum zur Beantragung dieser Wahlleistung ist abgelaufen.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row red\" ng-if=\"component.isPcBlocked\"\u003E\u003Cp class=\"red\"\u003EDie Wahlleistung PC Leasing ist leider gesperrt.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row red\" ng-if=\"component.disableCheckoutIfMultipleSachbezugCheckouts\"\u003E\u003Cbr\u003E\u003Cp class=\"red\"\u003ESie beantragen bereits die Wahlleistung - {{ component.sachbezugCheckedoutComponent }}. Bitte schließen Sie zuerst diese Beantragung ab.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cbutton class=\"button button-primary float-left\" ng-click=\"component.navigateBackToDashboard()\" data-cy=\"bonus.preCheckout.basicComponent.wizardBegin.buttonPrevious\"\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary float-right\" ng-click=\"component.addComponentToEmployeeBonusComponents()\" ng-if=\"component.isDecisionDateValid() &amp;&amp; !component.is_component_cashback &amp;&amp; component.canContinue()\" data-cy=\"bonus.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003E" + (pug.escape(null == (pug_interp = data.label_next_button || 'Weiter') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary float-right\" ng-click=\"component.continueToCashbackRequestStep()\" ng-if=\"component.isDecisionDateValid() &amp;&amp; component.is_component_cashback &amp;&amp; component.is_cashback_request_available\" data-cy=\"bonus.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003E" + (pug.escape(null == (pug_interp = data.label_next_button || 'Weiter') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'NEO_COMPONENT') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" overlay=\"!$ctrl.isLoaded\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'So funktioniert´s {{ $ctrl.neo_component.title }}') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E";
if (data.video) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.video, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
if (data.image) {
pug_html = pug_html + "\u003Cdiv class=\"baustein\"\u003E\u003Cdiv class=\"bausteinContainer\"\u003E\u003Ca" + (" class=\"imgWrapper\""+pug.attr("ng-href", '/module/' + data.image, true, true)) + "\u003E\u003Cdiv" + (" class=\"imgContainer\""+pug.attr("style", pug.style('background-image: url(/assets/img/bonus/' + data.image + '.jpg)'), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"subtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle2) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cbr\u003E";
block && block();
pug_html = pug_html + "\u003Cp class=\"red\" ng-if=\"$ctrl.isBlockedForPcLeasing\"\u003EDie Wahlleistung PC Leasing ist leider gesperrt.\u003C\u002Fp\u003E\u003Cbr\u003E\u003Cbutton class=\"button button-primary float-left\" ng-click=\"$ctrl.navigateBackToDashboard()\" data-cy=\"neo.preCheckout.basicComponent.wizardBegin.buttonPrevious\"\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cspan class=\"right\" ng-if=\"$ctrl.isLoaded\"\u003E\u003Cbutton class=\"button button-primary float-right\" ng-click=\"$ctrl.enterStepTwo()\" ng-if=\"$ctrl.canEnterStepTwo() &amp;&amp; $ctrl.doesUserHasSalary\" data-cy=\"neo.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003E" + (pug.escape(null == (pug_interp = data.label_next_button || 'Weiter') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Cdiv class=\"float-right\" ng-if=\"!$ctrl.canEnterStepTwo()\"\u003E\u003Cp class=\"error\"\u003EDer Abruf von PC-Leasing ist akuell nicht möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"float-right\" ng-if=\"!$ctrl.doesUserHasSalary\"\u003E\u003Cp class=\"error\"\u003EEine Beantragung ist aufgrund fehlender Einstellungen aktuell nicht möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
};
pug_mixins["values"] = pug_interp = function(data){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!data) { data={is_bonus: false}; }
if (data.process === 'NEO') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" ng-class=\"{highlighted: &quot;values&quot; == component.box.step}\"\u003E\u003Cdiv class=\"header\" ng-class=\"{show: &quot;values&quot; == component.box.step }\"\u003E\u003Ca ng-click=\"component.toggleStep(&quot;values&quot;)\"\u003E\u003Cspan class=\"step\"\u003E2\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"&quot;values&quot; == component.box.step\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2\"\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
if (data.description) {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Ca class=\"button button-primary right\" ng-disabled=\"!component.canExitValuesScreen()\" ng-click=\"component.toggleStep(&quot;checkout&quot;)\" data-cy=\"neo.preCheckout.basicComponent.wizardConfig.buttonNext\"\u003EWeiter\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'BONUS') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E2\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2 flex-column\"\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
if (data.description) {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv\u003E\u003Cbutton class=\"button button-primary left\" wz-cancel data-cy=\"bonus.preCheckout.basicComponent.wizardConfig.buttonCancel\"\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary right\" wz-next ng-disabled=\"!component.toAllowComponentAddition()\" ng-if=\"component.step2SelectionPossible()\" ng-click=\"component.stepValuesHandler &amp;&amp; component.stepValuesHandler()\" data-cy=\"bonus.preCheckout.basicComponent.wizardConfig.buttonConfirm\"\u003E" + (pug.escape(null == (pug_interp = data.step2ButtonTitle || 'Auswahl übernehmen') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'NEO_COMPONENT') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E2\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2 flex-column\"\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
if (data.description) {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv\u003E\u003Cbutton class=\"button button-primary left\" wz-cancel\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary right\" wz-next ng-disabled=\"!$ctrl.toAllowComponentAddition()\" ng-if=\"$ctrl.step2SelectionPossible()\" data-cy=\"neo.preCheckout.basicComponent.wizardConfig.buttonNext\"\u003EAuswahl übernehmen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
};































































































































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv ng-if=\"(component.loading.parent || component.loading.child)\"\u003ELoading\u003C\u002Fdiv\u003E\u003Cwizard hide-indicators=\"true\" ng-if=\"!(component.loading.parent || component.loading.child)\" on-finish=\"component.wizardFinished()\" on-cancel=\"component.wizardCanceled()\"\u003E\u003Cwz-step wz-title=\"Intro\" edit-mode=\"true\"\u003E";
pug_mixins["intro"].call({
block: function(){
pug_html = pug_html + "\u003Cp\u003EAuch die Umwelt atmet auf, denn durch die Fahrt mit dem Dienstrad tragen Sie erheblich zur Reduzierung des CO2-Ausstosses bei. Durch die Gehaltsumwandlung der Mietrate über Ihren Arbeitgeber erhalten Sie das Fahrvergnügen zum schlanken Preis, quasi Brutto für Netto – und das bei vollem Diebstahl-, Reparatur- und Versicherungsschutz. Da freut sich auch Ihr Geldbeutel. Übrigens, das Dienstrad kann auch ein E-Bike sein, so kommen Sie morgens ohne zu schwitzen am Arbeitsplatz an.\u003C\u002Fp\u003E\u003Cstrong\u003E Umsetzung Dienstrad im Zusammenhang mit Ihrem Budget\u003C\u002Fstrong\u003E\u003Cp\u003EEine Dienstradnutzung ist auf 36 Monate ausgelegt. Wenn Sie sich für ein Dienstrad entscheiden, reservieren Sie damit für 36 Monate den entsprechenden Betrag aus Ihrem Basisbudgetanspruch.\u003C\u002Fp\u003E\u003Cp ng-if=\"component.bikeleasing_permitted === true\"\u003E\u003Cstrong\u003EAus Ihrem freien Budget leitet sich ein maximaler Fahrradwert von {{ component.limits.max_bike_value | currency : \"\"}} EUR brutto ab.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp ng-if=\"component.bikeleasing_permitted === false\"\u003E\u003Cstrong\u003EIhr freies Budget reicht aktuell nicht aus, die Wahlleistung zu nutzen.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp ng-if=\"component.is_overspending_allowed === true\"\u003E\u003Cstrong\u003ESie können Ihr Dienstrad auch durch Entgeltumwandlung nutzen.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003EQ&A:\u003C\u002Fstrong\u003E Die wichtigsten Fragen und Antworten finden Sie unter&nbsp;\u003Ca href=\"https:\u002F\u002Fweconnect.in.fiduciagad.de\u002Fcommunities\u002Fservice\u002Fhtml\u002Fcommunityview?communityUuid=c07b5c3c-d081-4b26-bbbe-b32acea3e412#fullpageWidgetId=W039a60bfc22b_4cbd_b6c2_2c4dc05e22c8&amp;file=8354e11b-21e5-4b82-99e7-1b57a7e5e18e\" target=\"_blank\"\u003Ediesem Link\u003C\u002Fa\u003E(intern).\u003C\u002Fp\u003E\u003Cp\u003EÜber nachfolgenden Link gelangen Sie zur Website von Bikeleasing in den dort bereitgestellten Vergleichsrechner. Unter Angabe Ihres Firmencodes {{component.agCode}} wird dieser Rechner direkt auf die Konfiguration Ihres Arbeitgebers eingestellt. Hier können Sie sich errechnen, welcher Vorteil für Sie im Vergleich zu einem Direktkauf besteht.\u003C\u002Fp\u003E\u003Ca class=\"button button-primary\" target=\"_blank\" href=\"https:\u002F\u002Fwww.bikeleasing.de\u002Fleasingrechner\u002Farbeitnehmer\"\u003EVergleichsrechner (öffnet in neuem TAB)\u003C\u002Fa\u003E\u003Cp\u003E\u003Cstrong\u003EWeiterführende Informationen zu Bikeleasing\u003C\u002Fstrong\u003E\u003Cli\u003EInformationen zur Erweiterung des Versicherungs- und Inspektionsumfangs sind&nbsp;\u003Ca href=\"https:\u002F\u002Fwww.bikeleasing.de\u002Fvertragswerk\u002Fversicherungsuebersicht_brutto\" target=\"_blank\"\u003Ehier\u003C\u002Fa\u003E(extern) hinterlegt.\u003C\u002Fli\u003E\u003Cli\u003EInformationen zum Ablauf im Schadensfall entnehmen Sie&nbsp;\u003Ca href=\"https:\u002F\u002Fwww.bikeleasing.de\u002Fvertragswerk\u002Fablauf_im_schadensfall.pdf\" target=\"_blank\"\u003Ediesem Link\u003C\u002Fa\u003E(extern).\u003C\u002Fli\u003E\u003C\u002Fp\u003E";
}
}, {
      process: 'BONUS',
      video:       'https://www.youtube.com/embed/-JCTlCS1x1c',
      subtitle:    'Bikeleasing',
      subsubtitle: 'Bewegung, Motivation, Emotion. Ein nachhaltig gesundes Konzept, das sich garantiert für Sie rechnet - in mehrfacher Hinsicht: Sie tun etwas für Ihre Gesundheit und Fitness, Sie schonen die Umwelt und Ihren Geldbeutel. Umfahren Sie künftig den Stau zur Arbeit bequem mit Ihrem Dienstrad. So haben Sie morgens schon vor der Arbeit etwas für Ihre Gesundheit getan. Doch nicht nur Ihre Gesundheit profitiert von der Nutzung des Dienstrades. '
    });
pug_html = pug_html + "\u003C\u002Fwz-step\u003E\u003Cwz-step wz-title=\"Values\" edit-mode=\"true\" wz-data=\"{calculation_promise : component.calculation_promise}\" canenter=\"component.waitForCalculation\"\u003E";
pug_mixins["values"].call({
block: function(){
pug_html = pug_html + "\u003Cstrong\u003ESie möchten wissen wie es weitergeht?\u003C\u002Fstrong\u003E\u003Col\u003E\u003Cli\u003EHändlersuche\u003Cp\u003EFolgen Sie&nbsp;\u003Ca href=\"https:\u002F\u002Fbikeleasing.de\u002Fhaendler-finden#c23\" target=\"_blank\"\u003Ediesem Link\u003C\u002Fa\u003E(extern) und suchen sich Ihren Wunschhändler aus.\u003C\u002Fp\u003E\u003C\u002Fli\u003E\u003Cli\u003EDie Vorbereitung\u003Cp\u003EAuf dem Berechtigungsschein - Aufruf über den Knopf unten - haben wir Ihnen alle notwendigen Informationen für Ihren Händlerbesuch zusammengefasst. Weiter finden Sie dort auch die Informationen zum Datenschutz.\u003C\u002Fp\u003E\u003C\u002Fli\u003E\u003Cli\u003EBeim Händler vor Ort\u003Cp\u003EWenn Sie beim Händler Ihr Wunschfahrrad ausgesucht haben, benötigt dieser ein paar Informationen von Ihnen, um die Bestellung im ValueNet System zu integrieren.\u003C\u002Fp\u003E\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003Cstrong\u003EFirmencode Bikeleasing: {{component.agCode}}\u003C\u002Fstrong\u003E\u003Cp\u003EMit diesem 4-stelligen Code weisen Sie sich als berechtigter Arbeitnehmer Ihres Arbeitgebers aus.\u003C\u002Fp\u003E\u003Cstrong\u003EIhre ValueNetID:\u003C\u002Fstrong\u003E\u003Cp\u003EDie ValueNetID ist Ihre persönliche Kennung im gesamten ValueNet Umfeld. Die Nummer finden Sie oben rechts neben Ihrem Namen. Beim Händler wird diese als Personalnummer\u002FValueNetID angegeben. Fragt der Händler nach Ihrer Personalnummer, so benötigt er Ihre ValueNetID.\u003C\u002Fp\u003E\u003Cstrong\u003EIhre E-Mail Adresse:\u003C\u002Fstrong\u003E\u003Cp\u003EMit der E-Mail Adresse registriert der Händler Sie bei Bikeleasing, damit Sie später auch auf Ihren Vertrag Zugriff haben und im Falle eines Schadens schnell reagieren können. Weiter erhalten Sie durch den Dienstradanbieter direkt die Vertragsunterlagen zugeschickt und werden hier über den weiteren Ablauf wie z.B. Abholtermin informiert.\u003C\u002Fp\u003E\u003Cp\u003EWir haben für Sie die benötigten Informationen im Berechtigungsschein zusammengefasst, welchen Sie leicht abrufen und mit zum Händler nehmen können.\u003C\u002Fp\u003E\u003Cp\u003EInformationen zum Datenschutz von Bikeleasing können Sie&nbsp;\u003Ca href=\"https:\u002F\u002Fwww.bikeleasing.de\u002Fbikeleasing-service\u002Fwebsite\u002Fpdf\u002FBLS%20Information%20DSGVO.pdf\" target=\"_blank\"\u003Ediesem Link\u003C\u002Fa\u003E(extern) entnehmen.\u003C\u002Fp\u003E\u003Cbutton class=\"button-primary\" ng-click=\"component.generateBikeleasingDocument()\" data-cy=\"bonus.preCheckout.bikeLeasing2.wizardConfig.buttonEligibilityApplication\"\u003EBerechtigungsschein\u003C\u002Fbutton\u003E";
}
}, {
      process: 'BONUS',
      title: 'Bitte geben Sie folgende Daten zu Ihrem Fahrrad ein'
    });
pug_html = pug_html + "\u003C\u002Fwz-step\u003E\u003C\u002Fwizard\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;